import React from 'react'
import { Modal, Button, Form, Card } from 'react-bootstrap'
import moment from 'moment'
import 'moment/locale/pt-br'
import apinode from '../../services/apinode'
import { toast } from 'react-toastify'
import { FaUser, FaClock } from 'react-icons/fa' // Importe os ícones desejados

moment.locale('pt-br')

const ModalHistoricoPedido = ({
  show,
  onHide,
  historico,
  onInformarAndamento,
  pedido,
}) => {
  //  console.log(pedido)
  const [novoAndamento, setNovoAndamento] = React.useState('')

  const handleChangeNovoAndamento = (event) => {
    setNovoAndamento(event.target.value)
    console.log(event.target.value)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    const apiUrl = `/pedido/historico/${localStorage.idconta}`
    const dadosParaEnviar = {
      andamento: novoAndamento,
      id_user: localStorage.idusuario,
      pedido: pedido,
      // Adicione mais dados conforme necessário
    }

    apinode
      .post(apiUrl, dadosParaEnviar)
      .then((response) => {
        console.log('Sucesso:', response.data)
        toast.success(response.data.message)
        setNovoAndamento('')
        onInformarAndamento(pedido) // Atualize essa linha conforme necessário
      })
      .catch((error) => {
        toast.success(error)
        console.error('Erro:', error)
      })
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="custom-modalzpl"
    >
      <Modal.Header closeButton>
        <Modal.Title>Histórico do Pedido {pedido}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {historico
          .sort((a, b) => new Date(b.data) - new Date(a.data))
          .map((evento, index) => {
            const dataFormatada = moment(evento.data).format(
              'DD/MM/YYYY [às] HH:mm',
            )
            const tempoDecorrido = moment(evento.data).fromNow()
            return (
              <Card
                key={index}
                style={{ marginBottom: '10px' }}
              >
                <Card.Body>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '5px',
                    }}
                  >
                    <FaUser style={{ marginRight: '5px' }} />{' '}
                    {/* Ícone de usuário */}
                    <Card.Subtitle className="mb-2 text-muted">
                      {evento.nome}
                    </Card.Subtitle>
                  </div>
                  <Card.Text>{evento.texto}</Card.Text>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div
                      className="text-muted"
                      style={{ fontSize: 'smaller' }}
                    >
                      <FaClock style={{ marginRight: '5px' }} />{' '}
                      {/* Ícone de relógio */}
                      {dataFormatada} ({tempoDecorrido})
                    </div>
                    {/* Adicione aqui outros ícones conforme necessário */}
                  </div>
                </Card.Body>
              </Card>
            )
          })}

        <Form onSubmit={handleSubmit}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '10px',
            }}
          >
            <input
              type="text"
              value={novoAndamento}
              onChange={handleChangeNovoAndamento}
              placeholder="Digite o novo andamento"
              style={{ flex: 1, marginRight: '10px', padding: '5px' }}
              className="form-control"
            />
            <button
              onClick={handleSubmit}
              style={{
                padding: '5px 10px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Enviar
            </button>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
        >
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ModalHistoricoPedido
